import React from 'react';
import cx from 'classnames';
import { isObjectEmpty } from '@common/paymentsUtils/inputValidator';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import { Container as ZContainer } from '@zillow/zrs-comet';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import CaretLeft from '@zg-rentals/multibrand-ui/lib/icons/CaretLeft';
import { PDPHeader } from '@zg-rentals/zrm-utils-js';
import Skeleton from '@rental-manager/components/Skeleton';
import './index.scss';
import { IClusterSettingsModel, ICookieEnabledServiceModel, ILocationModel } from '@rental-manager/models/Types';
import { RouteComponentProps } from 'react-router-dom';

type Props = {
  propertyId: string;
  encodedLeaseId: string | string[] | null;
  getIreneDashboard: (...args: any) => void;
  location: ILocationModel;
  getListing: (propertyId: string) => any;
  signUrl: (...args: any) => void;
  clusterSettings: IClusterSettingsModel;
  isInWebView: boolean;
  cookieEnabledServices: ICookieEnabledServiceModel;
  children: (...args: Array<any>) => any;
  fromAggregateView: boolean;
};

type State = {
  isLoading: boolean;
  listing: { [key: string]: any };
};

class PropertyDetailsPage extends React.Component<Props & RouteComponentProps, State> {
  brand = 'zillow';

  state = {
    isLoading: true,
    listing: {
      propertyPhotos: [],
      photos: [],
    },
  };

  componentDidMount() {
    this.getListing();
    this.props.getIreneDashboard(this.props.propertyId, this.props.encodedLeaseId);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !nextState.isLoading;
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.getListing();
    }
  }

  getListing = () => {
    const { propertyId } = this.props;
    this.props.getListing(propertyId).then((response) => {
      this.setState({
        isLoading: false,
        listing: response.error ? {} : response,
      });
    });
  };

  signUrl = async (url, brand) => {
    const params = { brandName: brand };
    return this.props.signUrl(url, params);
  };

  renderPDP = () => {
    const { listing } = this.state;
    const { clusterSettings, children, location, isInWebView, cookieEnabledServices, fromAggregateView } = this.props;
    // FIXME: RMW remapped the default response name of photos but PDPHeader expects propertyPhotos
    listing.propertyPhotos = listing.photos;

    const tabConfig = {
      payments: {
        tabComponent: children({ listing, clusterSettings }),
      },
    };

    const { hostApp } = cookieEnabledServices;
    const isInMobileWebView = hostApp === 'ios' || hostApp === 'android';

    return (
      <div
        className={cx({
          'PDP-page-native': isInWebView,
        })}
      >
        <PDPHeader
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          brand={this.brand}
          tabConfig={tabConfig}
          isInMobileWebView={isInMobileWebView}
          customHrefValue={fromAggregateView ? '/rental-manager/rent-payment/overview' : undefined}
          customDisplayName={fromAggregateView ? 'Back' : undefined}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          listing={listing}
          pathname={location.pathname}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          signMapUrl={this.signUrl}
        />
      </div>
    );
  };

  renderListingNotFound = () => {
    const goToLink = '/rental-manager/properties';

    return (
      <ZContainer className="PropertyDetailsPage-content">
        <div className="PropertyDetailsPage-Breadcrumb">
          <Container className="HeaderNav-container-fluid">
            <Row>
              <Col>
                <div className="BreadcrumbBack-Container">
                  <Link className="BreadcrumbBack-Link" href={goToLink}>
                    <CaretLeft className="BreadcrumbBack-Chevron" size={15} />
                    <Text className="BreadcrumbBack-Name">My properties</Text>
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Container className="PropertyDetailsPage-ListingNotFound-Container">
          <Row>
            <Col>
              <Text type="h4">Listing not found</Text>
            </Col>
          </Row>
        </Container>
      </ZContainer>
    );
  };

  renderSkeleton = () => <Skeleton />;

  render() {
    const { isLoading, listing } = this.state;
    if (isLoading) {
      return this.renderSkeleton();
    }

    const hasListing = !isObjectEmpty(listing);
    if (hasListing) {
      return this.renderPDP();
    } else {
      return this.renderListingNotFound();
    }
  }
}

export default PropertyDetailsPage;
